import { supabase } from '@/lib/supabase'

export interface UpdateUserRolePayload {
  userId: string
  roleId: string
}

export interface UpdateUserFranchisesPayload {
  userId: string
  franchiseRegions: string[]
}

async function invokeManageUser(action: string, body: Record<string, any>) {
  const { data: session } = await supabase.auth.getSession()
  if (!session.session) throw new Error('No session')

  const { data, error } = await supabase.functions.invoke('manage-user', {
    body: {
      action,
      ...body
    }
  })

  if (error) throw error
  return data
}

export function updateUserRole({ userId, roleId }: UpdateUserRolePayload) {
  return invokeManageUser('update_role', {
    user_id: userId,
    role_id: roleId
  })
}

export function updateUserFranchises({ userId, franchiseRegions }: UpdateUserFranchisesPayload) {
  return invokeManageUser('update_franchises', {
    user_id: userId,
    franchise_regions: franchiseRegions
  })
}

export type ManageUserActionPayload = {
  action: string
  userId: string
} & Record<string, any>

export function manageUserAction({ action, userId, ...params }: ManageUserActionPayload) {
  return invokeManageUser(action, {
    user_id: userId,
    ...params
  })
}
